import { useMediaQuery } from '@mui/material';
import { useGetWhiteLabelUnauthorized } from '@portal-middleware/hooks';
import { useGetSessionInfo } from '@sentinel/hooks';
import { AccountMenu } from '@vestwell-frontend/elements';
import {
  ApiBoundary,
  NavbarLogo,
  PageContainer,
  SkipToMainContentButton,
  Style,
  Topbar
} from '@vestwell-frontend/ui';

import { FC, ReactNode, useMemo } from 'react';
import { useLocation } from 'react-use';

import { routes } from '../routes';

export const NavbarLayout: FC<{ children: ReactNode }> = props => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const location = useLocation();

  const user = useGetSessionInfo('user', {
    query: {
      suspense: true,
      useErrorBoundary: false
    }
  });

  const whitelabel = useGetWhiteLabelUnauthorized({
    query: {
      keepPreviousData: true,
      suspense: true,
      useErrorBoundary: true
    }
  });

  const homeLink = useMemo(() => {
    return user?.data?.type != 'giftor' &&
      !location.pathname.includes('/gifting/account')
      ? location.pathname
      : routes.GiftingAccountDashboard;
  }, [location.pathname]);

  const handleLogoClick = () => {
    window.location.href = homeLink;
  };

  return (
    <PageContainer>
      <Style />
      <Topbar role='navigation'>
        <SkipToMainContentButton />
        <NavbarLogo
          alt={`${
            whitelabel.data?.registration?.name ?? 'Vestwell'
          } - Back to Gifting Dashboard`}
          onClick={handleLogoClick}
          src={
            isMobile
              ? whitelabel.data?.navbar?.logo?.mobile
              : whitelabel.data?.navbar?.logo?.desktop
          }
          to={homeLink}
        />
        {user.data && <AccountMenu />}
      </Topbar>
      <ApiBoundary>{props.children}</ApiBoundary>
    </PageContainer>
  );
};
